/**
 *  @class
 *  @function CartRemove
 *
 *  CRT-004. This is the control that empties a line, and it shipped as a bare custom element:
 *  no role, no tab stop, no accessible name, and a click listener as its only input. A keyboard
 *  could not reach it and a screen reader read nothing, in the drawer and on the cart page
 *  alike. The name comes from the markup, where the product is known; everything else belongs
 *  to the component so all three places it is rendered gain it at once.
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
      if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
      this.addEventListener('click', this.onClickHandler.bind(this));
      this.addEventListener('keydown', this.onKeydownHandler.bind(this));
    }
    onKeydownHandler(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.onClickHandler(event);
    }
    onClickHandler(event) {
      event.preventDefault();
      const index = this.dataset.index;
      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.updateQuantity(index, '0');
      } else {
        document.dispatchEvent(new CustomEvent('cart:remove', { detail: { index } }));
      }
    }
  }
  customElements.define('cart-remove', CartRemove);
}
